export interface FeatureFlags {
    feedback: boolean;
}

/**
 * Lấy giá trị feature flag từ environment variables
 * @param key - Tên của feature flag
 * @param defaultValue - Giá trị mặc định nếu không tìm thấy
 */

const getFeatureFlag = (key: string, defaultValue: boolean = false) : boolean => {
    const envValue = process.env[`REACT_APP_FEATURE_${key.toUpperCase()}`];

    if(envValue === undefined) {
        return defaultValue;
    }

    return envValue === 'true';
}

export const featureFlags: FeatureFlags = {
    feedback: getFeatureFlag('FEEDBACK', false),
}

export const isFeatureEnabled = (feature: keyof FeatureFlags): boolean => {
    return featureFlags[feature];
}

if(process.env.NODE_ENV === 'development') {
    console.log('Feature Flags: ', featureFlags)
}